export type Inquiry = {
  id: string
  contractId: string
  description: string //申請内容
  failureDate: string //故障日(yyyy-mm-dd)
  source: string
  status: string
}

export type PostInquiryData = Pick<Inquiry, 'contractId' | 'description' | 'failureDate'>

// mi 系
export type InquiriesResponse = {
  totalNumber: number
  inquiries: MiInquiry[]
}

export type MiInquiry = {
  id: string
  contractId: string
  description: string
  failureDate: string
  source: sourceType
  status: statusType
  createdAt: string
  updatedAt: string
}

export const InquiryStatusMap = {
  New: '申請内容の確認中です',
  WaitingForProductArrival: '故障商品の確認中です',
  WaitingForCompleteFulfillment: '保証履行中です',
  Closed: '対応済みです',
} as const

type statusType = keyof typeof InquiryStatusMap
type sourceType = 'Web' | 'Phone' | 'Email'
